/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';

import { SectionTitle } from 'components';
import Button from 'components/Button/Button';
import ofertasService from 'services/remote/OfertasServiceNuevoOnboarding';
import { toast } from 'react-toastify';
import { OfertaRegistroAPI } from 'types/models/OfertasServiceNuevoOnboarding';
import configuration from 'config';
import OfertaForm from '../../OfertaForm';
import styles from './oferta.module.scss';

interface OfertaProps {
  ofertas: Partial<OfertaRegistroAPI>[];
  ofertasConNuevaLinea: Partial<OfertaRegistroAPI>[];
  setOfertas: (ofertas: Partial<OfertaRegistroAPI>[]) => void;
  inscritosID: string;
  loadingDataCreate: boolean;
  setLoadingDataCreate: (loading: boolean) => void;
  solicitudId: string;
  idComunidad: number;
}

const Oferta = ({
  ofertas,
  ofertasConNuevaLinea,
  setOfertas,
  inscritosID,
  loadingDataCreate,
  setLoadingDataCreate,
  solicitudId,
  idComunidad,
}: OfertaProps) => (
  <div>
    <SectionTitle text={I18n.t('Oferta.detalle')} />
    <div className={styles.urlMapa}>
      <a
        href={`${configuration.urlOfertas}comunitats/${idComunidad}/onboarding?sessionId=${solicitudId}&step=6`}
        target="_blank"
        rel="noreferrer"
        className={styles.shareButton}
      >
        {`${configuration.urlOfertas}comunitats/${idComunidad}/onboarding?sessionId=${solicitudId}&step=6`}
      </a>
    </div>
    <div style={{ marginBottom: '2rem' }}>
      <OfertaForm
        initialData={ofertasConNuevaLinea}
        onChange={(updatedArr) => {
          // Update the entire ofertas array with the new array
          setOfertas(updatedArr);
        }}
        solicitudId={solicitudId}
      />
    </div>
    <div className={styles.ofertaContainer}>
      <Button
        text={loadingDataCreate ? 'Creando.....' : I18n.t('Save')}
        loading={loadingDataCreate}
        onClick={async () => {
          setLoadingDataCreate(true);
          // 1. Filtrar las ofertas con al menos un valor
          const ofertasValidas = ofertas.filter((o) =>
            Object.values(o).some((val) => val !== undefined && val !== null && val !== ''),
          );

          const ofertasConID = ofertasValidas.map((oferta) => ({
            ...oferta,
            solicitud_de_registro: inscritosID,
          }));

          try {
            await Promise.all(
              ofertasConID.map((oferta) => {
                if (oferta.id) {
                  // ACTUALIZAR oferta existente
                  return ofertasService.updateOferta(solicitudId, oferta.id.toString(), oferta);
                }
                // CREAR nueva oferta
                return ofertasService.createOferta(inscritosID, oferta);
              }),
            );
            setOfertas([...ofertasValidas, {}]);
            toast.success(I18n.t('Ofertas guardadas correctamente'));
          } catch (error: any) {
            toast.error(error?.message || String(error) || 'Error desconocido');
            alert(error);
          } finally {
            setLoadingDataCreate(false);
          }
        }}
        type="button"
        variant="primary"
      />
    </div>
  </div>
);

export default Oferta;
